import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CategoryForm from '../../../../Componant/Application/Project/master/CategoryForm'


const CategoryContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CategoryForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CategoryContainer